import classnames from 'classnames/bind'
import React from 'react'

import GridListCard, { GridListCardProps } from '~/components/UI/GridListCard'
import { PaginationProps } from '~/components/UI/Pagination'
import Pagination from '~/components/UI/Pagination'

import { isEven, isOdd } from '~/utils/number-is-odd-or-even'

import css from './styles.module.scss'

const cx = classnames.bind(css)

export type GridListProps = PaginationProps & {
  className?: string
  layout?: 6 | 4
  hasPagination?: boolean
  hasReadMore?: boolean
  currentPage?: number
  items?: GridListCardProps[]
}

function GridList({
  className,
  layout,
  items,
  hasPagination,
  hasReadMore,
  ...props
}: GridListProps) {
  const { maxPage } = props
  const needsPagination = hasPagination && maxPage > 1

  return (
    <div className={cx(css.GridList, className, css?.[`layout-${layout}`])}>
      <div className={cx(css.content)}>
        {items?.map((item, index) => {
          const isDesktopLastInRow = index % layout === layout - 1
          const isMobileFirstInRow = isEven(index)
          const isMobileLastInRow = isOdd(index)

          return (
            <GridListCard
              {...item}
              hasReadMore={hasReadMore}
              className={cx(css.item, {
                isDesktopLastInRow,
                isMobileFirstInRow,
                isMobileLastInRow,
              })}
              key={`grid_item_${index}`}
            />
          )
        })}
      </div>
      {needsPagination && (
        <Pagination className={cx(css.pagination)} maxPage={maxPage} />
      )}
    </div>
  )
}

GridList.defaultProps = {
  layout: 4,
}

export default GridList
